import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import copy from './assets/copy.png';
import ReactGA from 'react-ga';
import { withTranslation, Trans } from 'react-i18next';

class ShareForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };

        this.codeGenerated = this.codeGenerated.bind(this);
    }

    removeMeta(obj) {
        for (var prop in obj) {
            if (prop === 'thumbnail') {
                delete obj[prop];
            } else if (prop === 'preview') {
                delete obj[prop];
            } else if (typeof obj[prop] === 'object') {
                this.removeMeta(obj[prop]);
            }
        }
    }

    codeGenerated() {
        this.setState({
            loading: true
        });

        var clone = JSON.parse(JSON.stringify(this.props.configuration));
       // console.log("Configuration being sent for code generation:", clone); see the config in the console
        this.removeMeta(clone);
        var ga = "";

        ReactGA.ga((tracker) => {
            ga = tracker.get('clientId');
        });

        fetch('/' + this.props.boat + '/CodeGenerated', {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify({
                configuration: JSON.stringify(clone),
                code: this.props.code,
                ga: ga
            })
        });
    }

    render() {
        return (
            <div>
                <h2><Trans defaults='Share' /></h2>
                <p>
                    <Trans defaults='Share Text 1' />
                    <br />
                    <Trans defaults='Share Text 2' />
                </p>
                <button className="button" style={{ marginRight: 15 }} onClick={() => { if (!this.state.expanded) { this.codeGenerated(); } this.setState({ expanded: !this.state.expanded }); }}><Trans defaults='Generate code' /></button>

                <div className={"expander" + (this.state.expanded ? " open" : " closed")}>
                    <p>
                        <input type="text" value={this.props.code} style={{ width: 262, verticalAlign: 'top', marginRight: 10 }} readOnly />

                        <CopyToClipboard text={this.props.code}>
                            <button className="secondary button"><img src={copy} alt="copy" /></button>
                        </CopyToClipboard>
                    </p>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ShareForm);



// WEBPACK FOOTER //
// ./src/ShareForm.js